/**
 * Deve ser o primeiro import de main.js para reduzir atraso até datadogRum.init().
 * Credenciais VUE_APP_DD_* são embutidas no build (Vue CLI), não em runtime no nginx.
 */
import { initializeDatadogRum } from './rum';

initializeDatadogRum();
